export const MUTATION_UPDATE = "MUTATION_UPDATE";
export const MUTATION_PUSH = "MUTATION_PUSH";
